<div class="ot-header-bar-delete-container" [ngClass]="messageClass">
  <!-- Progress -->
  <div class="ot-delete-header-content-container ot-progress" *ngIf="hbi.showProgress">
    <div class='ot-delete-header-message'>{{hbi.message}}</div>
    <div class='ot-delete-progress' [ngClass]="{'ot-short': !showStop()}">
      <file360-progress-bar [value]="deletes.deletePercentComplete"></file360-progress-bar>
    </div>
    <button *ngIf="showStop()" class='ot-delete-header-action' (click)="stopAll()">Stop</button>
    <button class='ot-delete-header-caret' (click)="onCaret()"
      [ngClass]="{'ot-up': hbi.showCaretUp, 'ot-down': hbi.showCaretDown}"></button>
  </div>

  <!-- No progress -->
  <div class="ot-delete-header-content-container ot-no-progress" *ngIf="!hbi.showProgress">
    <div class='ot-delete-message-container'>
      <img [src]="hbi.icon" class='ot-delete-header-icon'>
      <div class='ot-delete-header-message'>{{hbi.message}}</div>
    </div>
    <div class='ot-delete-error-count' *ngIf="deletes.deleteErrors == 1">{{deletes.deleteErrors}} error</div>
    <div class='ot-delete-error-count' *ngIf="deletes.deleteErrors > 1">{{deletes.deleteErrors}} errors</div>
    <button class='ot-delete-header-close' (click)="onClose()"></button>
  </div>

  <!-- Details -->
  <div *ngIf="isExpanded" class="ot-delete-detail-container">
    <div *ngFor="let delete of deletes.details" class="ot-delete-item"
      [ngClass]="{'ot-status-action': delete.state == DeleteDetailState.Waiting || delete.state == DeleteDetailState.Done || delete.state == DeleteDetailState.Error, 'ot-done': delete.state == DeleteDetailState.Done, 'ot-canceled' : delete.state == DeleteDetailState.Canceled, 'ot-error' : delete.state == DeleteDetailState.Error }">
      <div class='ot-delete-detail-message-container'>
        <img class="ot-delete-detail-icon" [src]="delete.icon">
        <div class="ot-delete-detail-name">{{delete.message}}</div>
      </div>
      <!-- No progress-->
      <div *ngIf="delete.state != DeleteDetailState.InProgress" class='ot-delete-status-text'
        [title]="delete.statusText">
        {{delete.statusText}}
      </div>
      <!-- Progress-->
      <div *ngIf="delete.state == DeleteDetailState.InProgress" class='ot-delete-status-progress'>
        <file360-loading-dots></file360-loading-dots>
      </div>
      <!-- Cancel button, only when waiting-->
      <button *ngIf="delete.state == DeleteDetailState.Waiting" class='ot-delete-cancel'
        (click)="stop(delete)"></button>
      <!-- No cancel button -->
      <img *ngIf="
        DeleteDetailTypeIcons[delete.state] && delete.state !=DeleteDetailState.Waiting" class='ot-delete-status-icon'
        [src]="DeleteDetailTypeIcons[delete.state]">
    </div>
  </div>
</div>